import { render, staticRenderFns } from "./FunnelHelp.vue?vue&type=template&id=28b640ae&scoped=true"
import script from "./FunnelHelp.vue?vue&type=script&lang=js"
export * from "./FunnelHelp.vue?vue&type=script&lang=js"
import style0 from "./FunnelHelp.vue?vue&type=style&index=0&id=28b640ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b640ae",
  null
  
)

export default component.exports